import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import Collapse from '@mui/material/Collapse';
import React from 'react';
import { Avatar } from 'src/components/Avatar';
import { Icon } from 'src/components/Icon';
import { Typography } from 'src/components/Typography';
import { User } from 'src/models/user/_types';
import { getUserInitials } from 'src/models/user/utils';

interface FabContentProps {
  itemCount: number;
  user?: User;
  showCheckIcon?: boolean;
  checkIconVisible?: boolean;
  text: string | React.ReactNode;
  showAvatar?: boolean;
}

export const FabContent: React.FC<FabContentProps> = ({
  itemCount,
  user,
  showCheckIcon = true,
  checkIconVisible = true,
  text,
  showAvatar = true,
}) => {
  return (
    <>
      {showCheckIcon && (
        <Collapse
          orientation="horizontal"
          in={checkIconVisible && itemCount > 0}
        >
          <Icon
            sx={{ mr: 0.5, mt: 0.5 }}
            icon={icon({ name: 'check', style: 'regular' })}
          />
        </Collapse>
      )}
      <Typography variant="body1" sx={{ ml: 1 }}>
        {text}
      </Typography>
      {showAvatar && user && (
        <Avatar
          sx={{ ml: 2 }}
          src={user?.profileImage}
          initials={user && getUserInitials(user)}
        />
      )}
    </>
  );
};
